import { BaseModel } from '@core/base/base-model';
import { SettingGroup } from '@shared/setting/setting-group.enum';

export class Setting extends BaseModel {
  group?: SettingGroup;
  code!: string;
  value?: string;
}
